import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl} from '@angular/forms';

@Component({
  selector: 'app-question-categories-filter',
  templateUrl: './question-categories-filter.component.html',
  styleUrls: ['./question-categories-filter.component.scss']
})
export class QuestionCategoriesFilterComponent implements OnInit {

  searchForm = this.formBuilder.group({
    description: [''],
  });

  get descriptionControl(): FormControl {
    return this.searchForm.get('description') as FormControl;
  }

  @Output()
  search: EventEmitter<string> = new EventEmitter<string>();

  constructor(private formBuilder: FormBuilder) { }

  ngOnInit(): void {
  }

  handleSubmit(): void {
    this.search.emit(this.descriptionControl.value);
  }

  clean(): void {
    this.search.emit('');
  }


}
